const parsePublicBoolean = (value: string | undefined, defaultValue: boolean) => {
  if (value == null) {
    return defaultValue;
  }

  return value.toLowerCase() === "true";
};

export const SIGNUP_WITH_SOCIAL_ENABLED = parsePublicBoolean(
  process.env.NEXT_PUBLIC_SIGNUP_WITH_SOCIAL_ENABLED,
  true
);

export const SIGNUP_WITH_APPLE_ENABLED = parsePublicBoolean(
  process.env.NEXT_PUBLIC_SIGNUP_WITH_APPLE_ENABLED,
  false
);

export const SIGNUP_WITH_GOOGLE_ENABLED = parsePublicBoolean(
  process.env.NEXT_PUBLIC_SIGNUP_WITH_GOOGLE_ENABLED,
  true
);

export const TUTORING_CENTRES_NL_SEARCH_V2_ENABLED = parsePublicBoolean(
  process.env.NEXT_PUBLIC_TUTORING_CENTRES_NL_SEARCH_V2_ENABLED,
  true
);